import { useEffect } from 'react';

let currencyContext = 'USD';

export function getCurrencyCode()
{
    return currencyContext;
}

/**
 * Round to whole cents. Use this any time a displayed amount also has to match an amount
 * we charge, since only whole cents can actually be collected.
 */
export function roundCurrency(amount) {
    amount = parseFloat(amount);
    if (Number.isNaN(amount)) {
        return 0;
    }

    return Math.round(amount * 100) / 100;
}

export function formatCurrency(amount) {
    amount = parseFloat(amount);
    if (Number.isNaN(amount)) {
        amount = 0;
    }

    return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyContext,
    }).format(amount.toFixed(2));
    //return `\$${parseFloat(amount).toFixed(2)}`;
}

export function getCurrencySymbol() {
    return formatCurrency(0)
        .replaceAll('.', '')
        .replaceAll('0', '')
        .replaceAll(',', '');
}

export function useSetCurrency(currency) {
    if (currency) {
        currencyContext = currency;
    }

    useEffect(() => {
        if (currency) {
            currencyContext = currency;
        }
    }, [currency]);
}
